<!--
component: SearchShiteiNo
author: Ken Nakamura
description: 位置指定道路番号検索画面
-->
<template>
  <section class="search-shitei-no">
    <div class="head-message">
      {{ headMessage }}
    </div>
    <v-container fluid>
      <v-row>
        <v-col cols=6>
          <v-row class="justify-center">
            <v-col cols=3>
              <v-text-field id="text-bango-1" ref="text1" v-model="bango1"
                solo type="tel" autocomplete="off" hide-details="auto"
                @focus="inputMode=1"
                @keyup="checkChar"
                class="text-h4 my-2 py-2"
                :class="{yellow: inputMode==1}"
              />
            </v-col>
            <v-col cols=1>
              <div class="text-h4 my-3 py-2">―</div>
            </v-col>
            <v-col cols=3>
              <v-text-field id="text-bango-2" v-model="bango2" ref="text2"
                solo type="tel" autocomplete="off" hide-details="auto"
                @focus="inputMode=2"
                @keyup="checkChar"
                class="text-h4 my-2 py-2"
                :class="{yellow: inputMode==2}"
              />
            </v-col>
            <v-col cols=1>
              <div class="text-h4 my-3 py-2">―</div>
            </v-col>
            <v-col cols=2>
              <v-text-field id="text-bango-3" v-model="bango3" ref="text3"
                solo type="tel" autocomplete="off" hide-details="auto"
                @focus="inputMode=3"
                @keyup="checkChar"
                class="text-h4 my-2 py-2"
                :class="{yellow: inputMode==3}"
              />
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols=10>
              <v-btn
                @click="search"
                :disabled="bango1=='' || bango2==''"
                primary x-large width="80%"
                class="text-h4 mx-2 my-4" >
                <v-icon color="#446666" class="mx-1">mdi-database-search</v-icon>
                検 索
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <tenkey-pad @pushed="tenkeyPushed" @clear="clearNo" />
        </v-col>
      </v-row>
    </v-container>
    <Dialog search :open="searching" :cancel="cancelDialog" title="検索中" />
    <Dialog error :open="onerror" :ok="closeDialog"
     title="指定道路番号検索" :body="errorMessage" :to="transition" />
    <Dialog message :open="canceled" :ok="closeDialog" title="指定道路番号検索" body="キャンセルされました" />
  </section>
</template>

<script>
import TenkeyPad from '../components/TenkeyPad.vue'
import Dialog from '../components/Dialog.vue'
//import { dbglog } from '../common/utils.js'
import { findShitei } from '../common/apiAccess.js'

export default {
  components: {
    TenkeyPad,
    Dialog,
  },
  data: () => {
    return {
      headMessage: "位置指定番号を入力して下さい",
      inputMode: 1,
      bango1: '',
      bango2: '',
      bango3: '',
      onerror: false,
      searching: false,
      canceled: false,
      controller: null,
      errorMessage: '',
      transition: '',
    }
  },
  props: {
  },
  watch: {
    bango1: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.text1.lazyValue = val;
          this.bango1 = val;
        }
      }
    },
    bango2: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.text2.lazyValue = val;
          this.bango2 = val;
        }
      }
    },
    bango3: {
      immediate: true,
      handler(val) {
        if (val) {
          val = parseInt(val);
          if (Number.isNaN(val) || val <= 0) {
            val = '';
          }
          this.$refs.text3.lazyValue = val;
          this.bango3 = val;
        }
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.errorMessage = 'ユーザが無効です。ログインし直して下さい。';
      this.transition = '/';
      this.onerror = true;
      //this.$router.replace('/');
    }
    this.$store.commit('setCurrentPage', 3);
    this.$refs.text1.focus();
    this.message = '位置指定道路図番号検索';
    const shiteiNo = this.$store.state.shiteiNo;
    if (shiteiNo) {
      this.bango1 = shiteiNo.nendo;
      this.bango2 = shiteiNo.bango;
      this.bango3 = shiteiNo.eda <= 0 ? '' : shiteiNo.eda;
    }
  },
  computed: {
    mode: {
      get() { return this.$store.state.mode; },
      set(val) { this.$store.commit('setMode', val); }
    },
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val); }
    },
  },
  methods: {
    tenkeyPushed(n) {
      switch (this.inputMode) {
      case 1:
        this.bango1 = this.bango1 * 10 + n;
        break;
      case 2:
        this.bango2 = this.bango2 * 10 + n;
        break;
      case 3:
        this.bango3 = this.bango3 * 10 + n;
        break;
      }
    },
    clearNo() {
      switch (this.inputMode) {
      case 1:
        this.bango1 = '';
        break;
      case 2:
        this.bango2 = '';
        break;
      case 3:
        this.bango3 = '';
        break;
      }
    },
    checkChar () {
      switch (this.inputMode) {
      case 1:
        this.bango1 = this.bango1.replace(/[^0-9]/g, '');
        break;
      case 2:
        this.bango2 = this.bango2.replace(/[^0-9]/g, '');
        break;
      case 3:
        this.bango3 = this.bango3.replace(/[^0-9]/g, '');
        break;
      }
    },
    search() {
      let eda = this.bango3;
      if (eda == 0 || eda == '') {
        eda = -1;
      }
      this.searching = true;
      this.$store.commit('setShiteiNo', {nendo: this.bango1, bango:this.bango2, eda:eda});
      this.controller = findShitei(this.bango1, this.bango2, eda, (data) => {
        this.searching = false;
        if (data === null || data.length === undefined || data.length == 0) {
          this.errorMessage = '指定道路図データが見つかりません';
          this.onerror = true;
        }
        else if (data.length == 1) {
          const rec = data[0];
          this.$router.push({
            name: 'browse-sproad',
            params: { id: rec.id } 
          });
        }
        else {
          this.$store.commit('setSummaries', data);
          this.$router.push({ name: 'list-result', params: { listId: 0 }});
        }
      });
    },
    closeDialog() {
      this.searching = false;
      this.onerror = false;
      this.canceled = false;
      this.transition = '';
    },
    cancelDialog() {
      if (this.controller !== undefined && this.controller !== null) {
        this.controller.abort();
      }
      this.searching = false;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>